import { MapPin, Facebook, Linkedin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import emailjs from "@emailjs/browser";

const Footer = () => {
  const whatsappMessage =
    "¡Hola Sergen! Vi esto en su página web y me interesa conocer más sobre sus servicios de eficiencia energética.";

  const [email, setEmail] = useState("");

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const result = await emailjs.send(
        "service_xxftmof",       // ✔ tu service ID
        "template_q3cxntf",      // ✔ tu template ID
        {
          name: "Suscripción Newsletter",
          email: email,
          message: "Nuevo suscriptor del newsletter"
        },
        "zPFsGWM__hwjs2vAc"      // ✔ tu public key
      );

      console.log("Email enviado:", result);

      alert("¡Gracias por suscribirte! Pronto recibirás novedades.");
      setEmail("");
    } catch (error) {
      console.error("Error enviando email:", error);
      alert("Hubo un error, intenta nuevamente.");
    }
  };

  return (
    <footer className="bg-[#0B1221] text-gray-300">
      <div className="container mx-auto px-4 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

          {/* LOGO + DESCRIPCIÓN + REDES */}
          <div>
            <img
              src="/lovable-uploads/2197224b-fa23-4967-8688-bc80f5152704.png"
              alt="Sergen Logo"
              className="h-14 mb-4"
            />

            <p className="text-gray-400 leading-relaxed">
              Revolucionamos la gestión energética con tecnología para un consumo más inteligente.
            </p>

            <div className="flex space-x-4 mt-5">
              <a
                href="https://www.facebook.com/people/Sergen-Eficiencia-Energ%C3%A9tica/61580870736985/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#f4a320] transition-colors"
              >
                <Facebook className="h-6 w-6" />
              </a>

              <a
                href="https://www.linkedin.com/company/sergen-eficiencia-energ%C3%A9tica/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#f4a320] transition-colors"
              >
                <Linkedin className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* ENLACES */}
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              {[
                { to: "/", text: "Inicio" },
                { to: "/nosotros", text: "Nosotros" },
                { to: "/servicios", text: "Servicios" },
                { to: "/contacto", text: "Contacto" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-[#f4a320] transition-colors"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACTO */}
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Contacto</h3>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-[#f4a320]" />
                info@sergen.pe
              </div>

              <div className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-[#f4a320]" />
                +51 985 138 443
              </div>

              <div className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-[#f4a320]" />
                Lima, Perú
              </div>
            </div>
          </div>

          {/* NEWSLETTER CON EMAILJS */}
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Newsletter</h3>
            <p className="text-gray-400 mb-4">
              Recibe tips de eficiencia energética
            </p>

            <form onSubmit={handleNewsletter} className="flex gap-2">
              <input
                type="email"
                placeholder="Tu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 focus:border-[#f4a320] outline-none"
              />

              <button
                type="submit"
                className="bg-[#f4a320] text-black px-5 py-2 rounded-lg font-semibold hover:bg-[#d88900] transition-colors"
              >
                Enviar
              </button>
            </form>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-12 pt-6 text-center text-gray-500">
          <p>&copy; {new Date().getFullYear()} SERGEN. Todos los derechos reservados.</p>
        </div>
      </div>

      {/* WHATSAPP */}
      <a
        href={`https://wa.me/51985138443?text=${encodeURIComponent(whatsappMessage)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-600 p-3 rounded-full shadow-lg hover:bg-green-700 transition-colors"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/767px-WhatsApp.svg.png"
          alt="WhatsApp"
          className="h-8 w-8"
        />
      </a>
    </footer>
  );
};

export default Footer;
